import { put, takeLatest, call, spawn, all } from 'redux-saga/effects';
import { passwordActions } from '../../../application/actions/password';

import { loadingActions } from '../../../application/actions/ui_loaders';

import api from '../../api';

const apiPassword = api(process.env.REACT_APP_PASSWORD_API);

export function* createPassword(action) {
  try {
    yield put(loadingActions.changeStatusLoadingCreatePassword({ isLoading: true }));

    const { data, error } = yield call(apiPassword.post, 'v1/crear', action.payload);

    if (data)
      yield all([
        put(loadingActions.changeStatusLoadingCreatePassword({ isLoading: false })),
        put(passwordActions.createPasswordSuccess(data)),
      ]);
    else
      yield all([
        put(loadingActions.changeStatusLoadingCreatePassword({ isLoading: false })),
        put(passwordActions.createPasswordError(error)),
      ]);
  /* istanbul ignore next */
  } catch (err) {
    /* istanbul ignore next */
    console.error('saga error:', err);
    yield all([
      put(passwordActions.createPasswordError({ code: 500, message: err })),
      put(loadingActions.changeStatusLoadingCreatePassword({ isLoading: false })),
    ]);
  }
}

export function* watchCreatePassword() {
  yield takeLatest(passwordActions.createPassword.type, createPassword);
}
/* istanbul ignore next */
export default function* otpSaga() {
  yield spawn(watchCreatePassword);
}
